import './style.scss';
import AppSearchResultProfile from '../../components/app_searchResultProfile/AppSearchResultProfile';
import { InstructorSearchResultProfile } from '../../server/types';

interface AppSearchResultGridProps {
	title: string
	profiles: InstructorSearchResultProfile[]
}

function AppSearchResultGrid({title, profiles}: AppSearchResultGridProps) {
	
	return (
		<div className='section-content section-content-removed-padding'>
			<div className='app-explore-result-grid-label'>{title}</div>
			<div className='app-explore-result-grid-wrap'>
				{profiles?.map((profile: InstructorSearchResultProfile, index: number) => 
					<AppSearchResultProfile 
						profile={profile} 
						key={`profile-grid${index}`}
					/>
				)}
			</div>
		</div>
	)
}

export default AppSearchResultGrid
